import { arrondiPrix } from '@/helpers/utils'

export default function afficherPrix6 (valeur) {
  return arrondiPrix(valeur, 6);
}